import React from "react";

const businessUnits = [
  {
    label: "WINREVO AI",
    title: "Cashflow Engine",
    subtitle: "Untuk UMKM hingga perusahaan menengah",
    items: [
      "Customer Service",
      "Sales",
      "WhatsApp",
      "Website",
      "Follow-up",
      "Business Automation",
    ],
    footer: (
      <>
        Target:{" "}
        <span className="font-semibold text-gray-100">
          UMKM – perusahaan menengah
        </span>
      </>
    ),
  },
  {
    label: "WINREVO INDUSTRIAL",
    title: "Growth Engine",
    subtitle: "Untuk manufacturing & enterprise",
    items: [
      "Asset Management",
      "IoT",
      "Dashboard",
      "Digital Twin",
      "BIM",
      "3D Laser Scanning",
      "Industrial Automation",
    ],
    footer: (
      <>
        Target:{" "}
        <span className="font-semibold text-gray-100">
          Manufacturing, Energy, Mining, Oil & Gas,
          <br />
          Building, Infrastructure
        </span>
      </>
    ),
  },
  {
    label: "WINREVO SOFTWARE",
    title: "Recurring Revenue Engine",
    subtitle: "Platform WINREVO ONE",
    items: [
      "AI",
      "Dashboard",
      "Asset",
      "Energy",
      "IoT",
      "Data",
      "Automation",
    ],
    footer: (
      <>
        Satu platform — perusahaan tidak perlu banyak
        <br />
        sistem berdiri sendiri.
      </>
    ),
  },
  {
    label: "WINREVO DATA",
    title: "Data Intelligence Engine",
    subtitle: "Untuk perusahaan berbasis data",
    items: [
      "Data Analytics",
      "Business Intelligence",
      "Reporting",
      "Data Integration",
      "Predictive Analytics",
    ],
    footer: (
      <>
        Target:{" "}
        <span className="font-semibold text-gray-100">
          Enterprise & data-driven business
        </span>
      </>
    ),
  },
  {
    label: "WINREVO CONSULTING",
    title: "Transformation Engine",
    subtitle: "Untuk digital transformation",
    items: [
      "Digital Strategy",
      "Process Optimization",
      "System Integration",
      "Technology Consulting",
      "Implementation",
    ],
    footer: (
      <>
        Fokus:{" "}
        <span className="font-semibold text-gray-100">
          Operational & digital transformation
        </span>
      </>
    ),
  },
];

const BusinessCard = ({ unit }) => {
  return (
    <div className="group flex h-full min-h-[458px] flex-col border border-[#27303b] bg-[#111720] px-7 py-8 transition-all duration-300 hover:-translate-y-1 hover:border-[#00e5d4]/40">
      {/* Label */}
      <div className="mb-4 font-mono text-[11px] font-medium tracking-[0.12em] text-[#00e5d4]">
        {unit.label}
      </div>

      {/* Title */}
      <h3 className="mb-2 text-[18px] font-semibold leading-tight text-gray-100">
        {unit.title}
      </h3>

      {/* Subtitle */}
      <p className="mb-6 text-[13px] font-medium leading-relaxed text-gradient">
        {unit.subtitle}
      </p>

      {/* Items */}
      <ul className="space-y-3">
        {unit.items.map((item, index) => (
          <li
            key={index}
            className="flex items-center text-[13px] leading-relaxed text-[#8fa2bd]"
          >
            <span className="mr-3 text-[#34404e]">·</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>

      {/* Footer */}
      <div className="mt-auto pt-7">
        <div className="border-t border-[#27303b] pt-5 text-[12px] leading-relaxed text-[#8193ad]">
          {unit.footer}
        </div>
      </div>
    </div>
  );
};

const BusinessUnits = () => {
  return (
    <section id="business" className="bg-[#090d12] px-6 py-20 text-white sm:px-10 lg:px-[6.7%]">
      <div className="mx-auto max-w-[1150px]">
        {/* Section Header */}
        <div className="mb-14">
          <div className="mb-7 font-mono text-[11px] tracking-[0.18em] text-[#8fa2bd]">
            06 — UNIT BISNIS
          </div>

          <h2 className="mb-5 text-[34px] font-semibold tracking-[-0.02em] text-gray-100 sm:text-[40px]">
            Apa saja yang ada di WINREVO?
          </h2>

          <p className="text-[15px] leading-relaxed text-[#8fa2bd]">
            Lima business unit, dibangun untuk tahap pertumbuhan yang berbeda.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {businessUnits.map((unit, index) => (
            <BusinessCard key={index} unit={unit} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessUnits;